// **React Imports
import ReactDOM from 'react-dom/client'
import { RouterProvider } from 'react-router-dom'

// **MUI Imports
import { Box } from '@mui/material'

// **Store Imports
import { Provider } from 'react-redux'
import { store } from './store'

// **Context Imports
import { SettingsProvider } from './context/setting'

// **Component Imports

// **Theme Imports
import ThemeComponent from './theme/ThemeComponent'

// **Router Import
import router from './router/router'

//Event Emitter Class
class EventEmitter {
  constructor() {
    this.events = {}
  }

  on(eventName, listener) {
    if (!this.events[eventName]) {
      this.events[eventName] = []
    }
    this.events[eventName].push(listener)
  }

  off(eventName, listenerToRemove) {
    if (!this.events[eventName]) return

    this.events[eventName] = this.events[eventName].filter(
      (listener) => listener !== listenerToRemove
    )
  }

  emit(eventName, data) {
    const listeners = this.events[eventName]
    if (listeners) {
      listeners.forEach((listener) => listener(data))
    }
  }
}

window.eventEmitter = new EventEmitter()

const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(
  <Provider store={store}>
    <SettingsProvider>
      <ThemeComponent>
        <Box className="main-container">
          <RouterProvider router={router} />
        </Box>
      </ThemeComponent>
    </SettingsProvider>
  </Provider>
)
